import React from 'react';
import { Box } from 'rebass/styled-components';

import { layout } from '../../../constants/constants';
import useFeatureToggle from '../../hooks/use-feature-toggle/useFeatureToggle';
import { CardSliderGroupContent, FeatureToggle, IconPack } from '../../models/app-data-model';
import CardSliderCard from '../card-slider-card/card-slider-card';
import ShSlider from '../sh-slider/sh-slider';
import './card-slider.scss';

export type CardSliderProps = {
  content: CardSliderGroupContent;
  featureToggles: FeatureToggle[];
  corewellStyleOverrides?: boolean;
  iconPack: IconPack[];
};

const CardSlider: React.FC<CardSliderProps> = ({ content, featureToggles, iconPack, corewellStyleOverrides }: CardSliderProps) => {
  const cardSliderEnabled = useFeatureToggle('card-slider', featureToggles);

  if (!cardSliderEnabled) {
    return null;
  }

  return (
    <div className="card-slider">
      <Box className="card-slider-headline" width={layout.singleColWidth} marginX={'auto'}>
        <h2>{content.header}</h2>
      </Box>

      <ShSlider numberOfCards={content.cards?.length} slideWidthInPixels={372} iconPack={iconPack}>
        <div className="card-slider-cards">
          {content.cards?.map((card, index) => (
            <CardSliderCard key={`card-slider-card-${index}`} content={card?.card_slider_card} iconPack={iconPack} corewellStyleOverrides={corewellStyleOverrides} />
          ))}
        </div>
      </ShSlider>
    </div>
  );
};

export default CardSlider;
